import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "brands" };
const _hoisted_2 = { class: "brands__label" };
const _hoisted_3 = { class: "brands__ticker" };
const _hoisted_4 = { class: "brands__track" };
const _hoisted_5 = ["src", "alt", "onError"];
const _hoisted_6 = {
    key: 1,
    class: "brands__name"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _directive_reveal = _resolveDirective("reveal");
    return (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_2, [
            _createTextVNode(_toDisplayString(_ctx.$t('brands.label')), 1)
        ])), [
            [_directive_reveal]
        ]),
        _createElementVNode("div", _hoisted_3, [
            _createElementVNode("ul", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.loop, (brand, i) => {
                    return (_openBlock(), _createElementBlock("li", {
                        key: i,
                        class: "brands__item"
                    }, [
                        (_ctx.hasWorkingImage(brand))
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: _ctx.logoSrc(brand) || '',
                                alt: brand.name,
                                class: "brands__logo",
                                draggable: "false",
                                onError: ($event) => (_ctx.handleError(_ctx.logoSrc(brand)))
                            }, null, 40, _hoisted_5))
                            : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(brand.name), 1))
                    ]));
                }), 128))
            ])
        ])
    ]));
}
